import React, { Suspense } from "react";
import QuestionPage from "./components/QuestionPage";

export default ({}) => {
  return (
    <div>
      <Suspense fallback={<div />}>
        <section>
          <QuestionPage />
        </section>
      </Suspense>
    </div>
  );
};
